<template>
  <div class="container d-flex justify-content-center flex-column">
    <div class="view-image-center">
      <img
        src="https://cdn-2.powerbiz.asia/img/admin-saas/Store.png?updatedAt=1635392034840"
      />
      <div class="mt-3 pbz-font subtitle-md-medium" style="color: #1a1a1a">
        {{ $t('integration.empty_store_title') }}
      </div>

      <div
        class="mt-3 pbz-font body-md-regular"
        style="color: #999999"
        v-html="$t('integration.empty_store_desc')"
      />

      <div class="d-flex justify-content-center mt-5">
        <!-- Button add channel -->
        <div
          class="button-set-store"
          @click.prevent="
            () => (
              $emit('setModalContent', { key: 'listChannel', value: true }),
              $router.push({
                path: 'dashboard',
                query: { is_add_channel: 1, select_channel: 1 },
              })
            )
          "
        >
          <div
            class="integration__button pbz-font body-md-bold"
            style="width: 278px; height: 48px"
          >
            {{ $t('integration.addChannel') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptySaleschannel',
}
</script>

<style lang="scss">
.button-add-product {
  background: #0559cb !important;
  border: 1px solid #0559cb !important;
  color: #ffffff !important;
  height: 48px !important;
  width: 401px !important;
}
.button-tambah-produk {
  background: #0559cb !important;
  border: 1px solid #0559cb !important;
  color: #ffffff !important;
  height: 40px !important;
  width: 120% !important;
  font-size: 14px;
  margin-left: 8px;
}
.button-add-product:hover {
  background: #04449a !important;
}
.view-image-center {
  margin-top: 10%;
}
</style>
